/**
 * BucksCurrency - 自定义货币切换器，用于 Shopify 平台
 * BucksCurrency - Custom currency switcher for the Shopify platform
 */
class BucksCurrency {
  constructor(options = {}) {
    this.options = {
      selector: '.money',
      defaultCurrency: 'USD',
      exchangeRateUrl: 'https://raw.githubusercontent.com/zla5/exchangerate/main/exchangerate.json',
      ipLookupUrl: 'https://ipapi.co/json',
      autoSwitch: true,
      symbolPosition: 'before',
      dropdownSelector: ['.currency-value-picker-wrapper', '.header_currency-value-picker-wrapper', '.product_currency-value-picker-wrapper'],
      buttonClass: 'select-button select-button--mini',
      numberFormat: null,
      ...options
    };

    this.rates = {};
    this.currentCurrency = this.options.defaultCurrency;

    // 货币符号和位置
    this.symbols = {
      "USD": { symbol: "$", position: "before" },
      "AED": { symbol: "د.إ", position: "before" },
      "AFN": { symbol: "؋", position: "before" },
      "ALL": { symbol: "L", position: "before" },
      "AMD": { symbol: "֏", position: "before" },
      "ANG": { symbol: "ƒ", position: "before" },
      "AOA": { symbol: "Kz", position: "before" },
      "ARS": { symbol: "$", position: "before" },
      "AUD": { symbol: "A$", position: "before" },
      "AWG": { symbol: "ƒ", position: "before" },
      "AZN": { symbol: "₼", position: "before" },
      "BAM": { symbol: "KM", position: "after" },
      "BBD": { symbol: "Bds$", position: "before" },
      "BDT": { symbol: "৳", position: "before" },
      "BGN": { symbol: "лв", position: "after" },
      "BHD": { symbol: ".د.ب", position: "before" },
      "BIF": { symbol: "FBu", position: "before" },
      "BMD": { symbol: "$", position: "before" },
      "BND": { symbol: "B$", position: "before" },
      "BOB": { symbol: "Bs.", position: "before" },
      "BRL": { symbol: "R$", position: "after" },
      "BSD": { symbol: "B$", position: "before" },
      "BTN": { symbol: "Nu.", position: "before" },
      "BWP": { symbol: "P", position: "before" },
      "BYN": { symbol: "Br", position: "before" },
      "BZD": { symbol: "BZ$", position: "before" },
      "CAD": { symbol: "C$", position: "before" },
      "CDF": { symbol: "FC", position: "before" },
      "CHF": { symbol: "CHF", position: "before" },
      "CLP": { symbol: "$", position: "before" },
      "CNY": { symbol: "¥", position: "before" },
      "COP": { symbol: "$", position: "before" },
      "CRC": { symbol: "₡", position: "before" },
      "CUP": { symbol: "$", position: "before" },
      "CVE": { symbol: "$", position: "before" },
      "CZK": { symbol: "Kč", position: "after" },
      "DJF": { symbol: "Fdj", position: "before" },
      "DKK": { symbol: "kr", position: "before" },
      "DOP": { symbol: "RD$", position: "before" },
      "DZD": { symbol: "دج", position: "after" },
      "EGP": { symbol: "E£", position: "before" },
      "ERN": { symbol: "Nfk", position: "before" },
      "ETB": { symbol: "Br", position: "before" },
      "EUR": { symbol: "€", position: "after" },
      "FJD": { symbol: "FJ$", position: "before" },
      "FKP": { symbol: "£", position: "before" },
      "FOK": { symbol: "kr", position: "before" },
      "GBP": { symbol: "£", position: "before" },
      "GEL": { symbol: "₾", position: "before" },
      "GGP": { symbol: "£", position: "before" },
      "GHS": { symbol: "GH₵", position: "before" },
      "GIP": { symbol: "£", position: "before" },
      "GMD": { symbol: "D", position: "before" },
      "GNF": { symbol: "FG", position: "before" },
      "GTQ": { symbol: "Q", position: "before" },
      "GYD": { symbol: "$", position: "before" },
      "HKD": { symbol: "HK$", position: "before" },
      "HNL": { symbol: "L", position: "before" },
      "HRK": { symbol: "kn", position: "before" },
      "HTG": { symbol: "G", position: "before" },
      "HUF": { symbol: "Ft", position: "after" },
      "IDR": { symbol: "Rp", position: "before" },
      "ILS": { symbol: "₪", position: "before" },
      "IMP": { symbol: "£", position: "before" },
      "INR": { symbol: "₹", position: "before" },
      "IQD": { symbol: "ع.د", position: "before" },
      "IRR": { symbol: "﷼", position: "before" },
      "ISK": { symbol: "kr", position: "before" },
      "JEP": { symbol: "£", position: "before" },
      "JMD": { symbol: "J$", position: "before" },
      "JOD": { symbol: "د.ا", position: "before" },
      "JPY": { symbol: "¥", position: "before" },
      "KES": { symbol: "KSh", position: "before" },
      "KGS": { symbol: "сом", position: "before" },
      "KHR": { symbol: "៛", position: "before" },
      "KID": { symbol: "A$", position: "before" },
      "KMF": { symbol: "CF", position: "before" },
      "KRW": { symbol: "₩", position: "before" },
      "KWD": { symbol: "د.ك", position: "before" },
      "KYD": { symbol: "$", position: "before" },
      "KZT": { symbol: "₸", position: "before" },
      "LAK": { symbol: "₭", position: "before" },
      "LBP": { symbol: "ل.ل", position: "before" },
      "LKR": { symbol: "Rs", position: "before" },
      "LRD": { symbol: "$", position: "before" },
      "LSL": { symbol: "L", position: "before" },
      "LYD": { symbol: "ل.د", position: "before" },
      "MAD": { symbol: "د.م.", position: "after" },
      "MDL": { symbol: "L", position: "before" },
      "MGA": { symbol: "Ar", position: "before" },
      "MKD": { symbol: "ден", position: "before" },
      "MMK": { symbol: "K", position: "before" },
      "MNT": { symbol: "₮", position: "before" },
      "MOP": { symbol: "P", position: "before" },
      "MRU": { symbol: "UM", position: "before" },
      "MUR": { symbol: "Rs", position: "before" },
      "MVR": { symbol: "Rf", position: "before" },
      "MWK": { symbol: "MK", position: "before" },
      "MXN": { symbol: "$", position: "before" },
      "MYR": { symbol: "RM", position: "before" },
      "MZN": { symbol: "MT", position: "before" },
      "NAD": { symbol: "$", position: "before" },
      "NGN": { symbol: "₦", position: "before" },
      "NIO": { symbol: "C$", position: "before" },
      "NOK": { symbol: "kr", position: "before" },
      "NPR": { symbol: "Rs", position: "before" },
      "NZD": { symbol: "NZ$", position: "before" },
      "OMR": { symbol: "ر.ع.", position: "before" },
      "PAB": { symbol: "B/.", position: "before" },
      "PEN": { symbol: "S/", position: "after" },
      "PGK": { symbol: "K", position: "before" },
      "PHP": { symbol: "₱", position: "before" },
      "PKR": { symbol: "Rs", position: "before" },
      "PLN": { symbol: "zł", position: "after" },
      "PYG": { symbol: "₲", position: "before" },
      "QAR": { symbol: "ر.ق", position: "before" },
      "RON": { symbol: "lei", position: "after" },
      "RSD": { symbol: "дин.", position: "before" },
      "RUB": { symbol: "₽", position: "before" },
      "RWF": { symbol: "FRw", position: "before" },
      "SAR": { symbol: "ر.س", position: "before" },
      "SBD": { symbol: "SI$", position: "before" },
      "SCR": { symbol: "Rs", position: "before" },
      "SDG": { symbol: "ج.س.", position: "before" },
      "SEK": { symbol: "kr", position: "before" },
      "SGD": { symbol: "S$", position: "before" },
      "SHP": { symbol: "£", position: "before" },
      "SLE": { symbol: "Le", position: "before" },
      "SLL": { symbol: "Le", position: "before" },
      "SOS": { symbol: "Sh", position: "before" },
      "SRD": { symbol: "$", position: "before" },
      "SSP": { symbol: "£", position: "before" },
      "STN": { symbol: "Db", position: "before" },
      "SYP": { symbol: "£", position: "before" },
      "SZL": { symbol: "L", position: "before" },
      "THB": { symbol: "฿", position: "before" },
      "TJS": { symbol: "ЅМ", position: "before" },
      "TMT": { symbol: "m", position: "before" },
      "TND": { symbol: "د.ت", position: "after" },
      "TOP": { symbol: "T$", position: "before" },
      "TRY": { symbol: "₺", position: "before" },
      "TTD": { symbol: "TT$", position: "before" },
      "TVD": { symbol: "A$", position: "before" },
      "TWD": { symbol: "NT$", position: "before" },
      "TZS": { symbol: "Sh", position: "before" },
      "UAH": { symbol: "₴", position: "after" },
      "UGX": { symbol: "Sh", position: "before" },
      "UYU": { symbol: "$U", position: "before" },
      "UZS": { symbol: "лв", position: "before" },
      "VES": { symbol: "Bs.", position: "before" },
      "VND": { symbol: "₫", position: "after" },
      "VUV": { symbol: "Vt", position: "before" },
      "WST": { symbol: "T", position: "before" },
      "XAF": { symbol: "FCFA", position: "before" },
      "XCD": { symbol: "$", position: "before" },
      "XDR": { symbol: "SDR", position: "before" },
      "XOF": { symbol: "CFA", position: "before" },
      "XPF": { symbol: "₣", position: "before" },
      "YER": { symbol: "﷼", position: "before" },
      "ZAR": { symbol: "R", position: "before" },
      "ZMW": { symbol: "ZK", position: "before" },
      "ZWL": { symbol: "Z$", position: "before" }
    };

    // 合并千位和小数点分隔符的配置
    this.numberFormat = {
      "USD": { thousands: ",", decimal: "." },
      "EUR": { thousands: ".", decimal: "," },
      "BRL": { thousands: ".", decimal: "," },
      "CAD": { thousands: ",", decimal: "." },
      "CNY": { thousands: ",", decimal: "." },
      "JPY": { thousands: ",", decimal: ".", noDecimals: true },
      "GBP": { thousands: ",", decimal: "." },
      "AUD": { thousands: ",", decimal: "." },
      "CHF": { thousands: "'", decimal: "." },
      "ARS": { thousands: ".", decimal: "," },
      "CLP": { thousands: ".", decimal: "," },
      "AED": { thousands: ",", decimal: "." },
      "AFN": { thousands: ",", decimal: "." },
      "ALL": { thousands: ".", decimal: "," },
      "AMD": { thousands: ",", decimal: "." },
      "ANG": { thousands: ",", decimal: "." },
      "AOA": { thousands: ".", decimal: "," },
      "AWG": { thousands: ",", decimal: "." },
      "AZN": { thousands: ".", decimal: "," },
      "BAM": { thousands: ".", decimal: "," },
      "BBD": { thousands: ",", decimal: "." },
      "BDT": { thousands: ",", decimal: "." },
      "BGN": { thousands: " ", decimal: "," },
      "BHD": { thousands: ",", decimal: "." },
      "BIF": { thousands: ",", decimal: "." },
      "BMD": { thousands: ",", decimal: "." },
      "BND": { thousands: ",", decimal: "." },
      "BOB": { thousands: ".", decimal: "," },
      "BSD": { thousands: ",", decimal: "." },
      "BTN": { thousands: ",", decimal: "." },
      "BWP": { thousands: ",", decimal: "." },
      "BYN": { thousands: " ", decimal: "," },
      "BZD": { thousands: ",", decimal: "." },
      "CDF": { thousands: ",", decimal: "." },
      "COP": { thousands: ".", decimal: "," },
      "CRC": { thousands: ".", decimal: "," },
      "CUP": { thousands: ",", decimal: "." },
      "CVE": { thousands: " ", decimal: "," },
      "CZK": { thousands: " ", decimal: "," },
      "DJF": { thousands: ",", decimal: "." },
      "DKK": { thousands: ".", decimal: "," },
      "DOP": { thousands: ",", decimal: "." },
      "DZD": { thousands: ",", decimal: "." },
      "EGP": { thousands: ",", decimal: "." },
      "ERN": { thousands: ",", decimal: "." },
      "ETB": { thousands: ",", decimal: "." },
      "FJD": { thousands: ",", decimal: "." },
      "FKP": { thousands: ",", decimal: "." },
      "FOK": { thousands: ".", decimal: "," },
      "GEL": { thousands: " ", decimal: "," },
      "GGP": { thousands: ",", decimal: "." },
      "GHS": { thousands: ",", decimal: "." },
      "GIP": { thousands: ",", decimal: "." },
      "GMD": { thousands: ",", decimal: "." },
      "GNF": { thousands: ",", decimal: "." },
      "GTQ": { thousands: ",", decimal: "." },
      "GYD": { thousands: ",", decimal: "." },
      "HKD": { thousands: ",", decimal: "." },
      "HNL": { thousands: ",", decimal: "." },
      "HRK": { thousands: ".", decimal: "," },
      "HTG": { thousands: ",", decimal: "." },
      "HUF": { thousands: " ", decimal: "," },
      "IDR": { thousands: ".", decimal: "," },
      "ILS": { thousands: ",", decimal: "." },
      "IMP": { thousands: ",", decimal: "." },
      "INR": { thousands: ",", decimal: "." },
      "IQD": { thousands: ",", decimal: "." },
      "IRR": { thousands: ",", decimal: "." },
      "ISK": { thousands: ".", decimal: "," },
      "JEP": { thousands: ",", decimal: "." },
      "JMD": { thousands: ",", decimal: "." },
      "JOD": { thousands: ",", decimal: "." },
      "KES": { thousands: ",", decimal: "." },
      "KGS": { thousands: " ", decimal: "," },
      "KHR": { thousands: ",", decimal: "." },
      "KID": { thousands: ",", decimal: "." },
      "KMF": { thousands: ",", decimal: "." },
      "KRW": { thousands: ",", decimal: ".", noDecimals: true },
      "KWD": { thousands: ",", decimal: "." },
      "KYD": { thousands: ",", decimal: "." },
      "KZT": { thousands: " ", decimal: "," },
      "LAK": { thousands: ",", decimal: "." },
      "LBP": { thousands: ",", decimal: "." },
      "LKR": { thousands: ",", decimal: "." },
      "LRD": { thousands: ",", decimal: "." },
      "LSL": { thousands: ",", decimal: "." },
      "LYD": { thousands: ",", decimal: "." },
      "MAD": { thousands: ",", decimal: "." },
      "MDL": { thousands: ",", decimal: "." },
      "MGA": { thousands: ",", decimal: "." },
      "MKD": { thousands: ".", decimal: "," },
      "MMK": { thousands: ",", decimal: "." },
      "MNT": { thousands: " ", decimal: "," },
      "MOP": { thousands: ",", decimal: "." },
      "MRU": { thousands: ",", decimal: "." },
      "MUR": { thousands: ",", decimal: "." },
      "MVR": { thousands: ",", decimal: "." },
      "MWK": { thousands: ",", decimal: "." },
      "MXN": { thousands: ",", decimal: "." },
      "MYR": { thousands: ",", decimal: "." },
      "MZN": { thousands: ".", decimal: "," },
      "NAD": { thousands: ",", decimal: "." },
      "NGN": { thousands: ",", decimal: "." },
      "NIO": { thousands: ",", decimal: "." },
      "NOK": { thousands: " ", decimal: "," },
      "NPR": { thousands: ",", decimal: "." },
      "NZD": { thousands: ",", decimal: "." },
      "OMR": { thousands: ",", decimal: "." },
      "PAB": { thousands: ",", decimal: "." },
      "PEN": { thousands: ",", decimal: "." },
      "PGK": { thousands: ",", decimal: "." },
      "PHP": { thousands: ",", decimal: "." },
      "PKR": { thousands: ",", decimal: "." },
      "PLN": { thousands: " ", decimal: "," },
      "PYG": { thousands: ".", decimal: "," },
      "QAR": { thousands: ",", decimal: "." },
      "RON": { thousands: ".", decimal: "," },
      "RSD": { thousands: ".", decimal: "," },
      "RUB": { thousands: " ", decimal: "," },
      "RWF": { thousands: ",", decimal: "." },
      "SAR": { thousands: ",", decimal: "." },
      "SBD": { thousands: ",", decimal: "." },
      "SCR": { thousands: ",", decimal: "." },
      "SDG": { thousands: ",", decimal: "." },
      "SEK": { thousands: " ", decimal: "," },
      "SGD": { thousands: ",", decimal: "." },
      "SHP": { thousands: ",", decimal: "." },
      "SLE": { thousands: ",", decimal: "." },
      "SLL": { thousands: ",", decimal: "." },
      "SOS": { thousands: ",", decimal: "." },
      "SRD": { thousands: ",", decimal: "." },
      "SSP": { thousands: ",", decimal: "." },
      "STN": { thousands: ".", decimal: "," },
      "SYP": { thousands: ",", decimal: "." },
      "SZL": { thousands: ",", decimal: "." },
      "THB": { thousands: ",", decimal: "." },
      "TJS": { thousands: " ", decimal: "," },
      "TMT": { thousands: " ", decimal: "," },
      "TND": { thousands: ",", decimal: "." },
      "TOP": { thousands: ",", decimal: "." },
      "TRY": { thousands: ".", decimal: "," },
      "TTD": { thousands: ",", decimal: "." },
      "TVD": { thousands: ",", decimal: "." },
      "TWD": { thousands: ",", decimal: "." },
      "TZS": { thousands: ",", decimal: "." },
      "UAH": { thousands: " ", decimal: "," },
      "UGX": { thousands: ",", decimal: "." },
      "UYU": { thousands: ".", decimal: "," },
      "UZS": { thousands: " ", decimal: "," },
      "VES": { thousands: ".", decimal: "," },
      "VND": { thousands: ".", decimal: "," },
      "VUV": { thousands: ",", decimal: "." },
      "WST": { thousands: ",", decimal: "." },
      "XAF": { thousands: ",", decimal: "." },
      "XCD": { thousands: ",", decimal: "." },
      "XDR": { thousands: ",", decimal: "." },
      "XOF": { thousands: ",", decimal: "." },
      "XPF": { thousands: ",", decimal: "." },
      "YER": { thousands: ",", decimal: "." },
      "ZAR": { thousands: " ", decimal: "." },
      "ZMW": { thousands: ",", decimal: "." },
      "ZWL": { thousands: ",", decimal: "." },
      "default": { thousands: ",", decimal: "." }
    };

    // 合并默认 numberFormat 和用户传入的 numberFormat
    this.numberFormat = {
      ...this.numberFormat,
      ...(this.options.numberFormat || {})
    };

    // 绑定方法
    this.fetchExchangeRates = this.fetchExchangeRates.bind(this);
    this.detectCurrencyFromIP = this.detectCurrencyFromIP.bind(this);
    this.processMoneyElements = this.processMoneyElements.bind(this);
    this.convertElement = this.convertElement.bind(this);
    this.createCurrencyDropdown = this.createCurrencyDropdown.bind(this);
    this.switchCurrency = this.switchCurrency.bind(this);
    this.observePriceChanges = this.observePriceChanges.bind(this);

    this.init();
  }

async init() {
    try {
        console.log('currency-switcher.js 初始化');
        if (typeof this.fetchExchangeRates !== 'function') {
            throw new Error('fetchExchangeRates is not a function.');
        }
        await this.fetchExchangeRates();

        const urlParams = new URLSearchParams(window.location.search);
        const urlCurrency = urlParams.get('currency')?.toUpperCase();
        const countryCode = localStorage.getItem('countryCode');
        const selectedCountry = localStorage.getItem('selectedCountry');
        const savedCurrency = localStorage.getItem('bucksCurrency');

        // 检查国家和国家代码是否缺失，触发 IP 检测
        if (this.options.autoSwitch && (!countryCode || !selectedCountry)) {
            await this.detectCurrencyFromIP();
        }

        // 处理货币选择
        if (urlCurrency && this.rates[urlCurrency]) {
            this.currentCurrency = urlCurrency;
            try {
                localStorage.setItem('bucksCurrency', urlCurrency);
                console.log('currency-switcher.js 使用 URL 货币并保存:', this.currentCurrency);
            } catch (error) {
                console.error('currency-switcher.js 保存到 localStorage 失败:', error);
            }
        } else if (savedCurrency && this.rates[savedCurrency]) {
            this.currentCurrency = savedCurrency;
            console.log('currency-switcher.js 使用已保存的货币:', this.currentCurrency);
        } else if (this.options.autoSwitch && !savedCurrency) {
            await this.detectCurrencyFromIP(); // 仅在无 URL 货币和本地货币时，尝试通过 IP 设置货币
        } else {
            this.currentCurrency = this.options.defaultCurrency;
            console.log('currency-switcher.js 使用默认货币:', this.currentCurrency);
        }

        this.processMoneyElements();
        this.createCurrencyDropdown();
        document.addEventListener('currency:change', (e) => this.switchCurrency(e.detail.currency));
        this.observePriceChanges();
    } catch (error) {
        console.error('currency-switcher.js 初始化错误:', error);
    }
}

  async fetchExchangeRates() {
    try {
      const response = await fetch(this.options.exchangeRateUrl);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      this.rates = await response.json();
      console.log('currency-switcher.js 汇率数据获取成功:', this.rates);
    } catch (error) {
      console.error('currency-switcher.js 获取汇率时出错:', error);
      this.rates = {
        "USD": 1, "AED": 3.6725, "AFN": 73.043, "ALL": 92.3393, "AMD": 394.3151, "ANG": 1.79,
        "AOA": 918.6392, "ARS": 1066.04, "AUD": 1.5853, "AWG": 1.79, "AZN": 1.699, "BAM": 1.8049,
        "BBD": 2.0, "BDT": 121.5771, "BGN": 1.8048, "BHD": 0.376, "BIF": 2970.7813, "BMD": 1.0,
        "BND": 1.3307, "BOB": 6.9401, "BRL": 5.7646, "BSD": 1.0, "BTN": 87.1364, "BWP": 13.7483,
        "BYN": 3.2519, "BZD": 2.0, "CAD": 1.4354, "CDF": 2854.7913, "CHF": 0.8796, "CLP": 929.3147,
        "CNY": 7.2401, "COP": 4130.8902, "CRC": 504.7632, "CUP": 24.0, "CVE": 101.7558, "CZK": 23.0599,
        "DJF": 177.721, "DKK": 6.8835, "DOP": 62.4891, "DZD": 134.023, "EGP": 50.6761, "ERN": 15.0,
        "ETB": 127.1689, "EUR": 0.9228, "FJD": 2.2937, "FKP": 0.7742, "FOK": 6.8835, "GBP": 0.7742,
        "GEL": 2.7772, "GGP": 0.7742, "GHS": 15.5814, "GIP": 0.7742, "GMD": 72.6622, "GNF": 8636.6648,
        "GTQ": 7.7306, "GYD": 209.7785, "HKD": 7.7712, "HNL": 25.6173, "HRK": 6.9531, "HTG": 131.247,
        "HUF": 367.6899, "IDR": 16306.8432, "ILS": 3.6174, "IMP": 0.7742, "INR": 87.1367, "IQD": 1314.4338,
        "IRR": 42058.6726, "ISK": 135.5052, "JEP": 0.7742, "JMD": 156.9421, "JOD": 0.709, "JPY": 147.827,
        "KES": 129.1384, "KGS": 87.4319, "KHR": 4016.9174, "KID": 1.5853, "KMF": 454.0026, "KRW": 1445.6563,
        "KWD": 0.3082, "KYD": 0.8333, "KZT": 491.7884, "LAK": 21869.2096, "LBP": 89500.0, "LKR": 295.0577,
        "LRD": 200.3179, "LSL": 18.2279, "LYD": 4.8825, "MAD": 9.7301, "MDL": 18.4224, "MGA": 4665.711,
        "MKD": 56.8584, "MMK": 2102.8702, "MNT": 3455.3724, "MOP": 8.0043, "MRU": 40.0144, "MUR": 45.1318,
        "MVR": 15.4368, "MWK": 1745.4316, "MXN": 20.2728, "MYR": 4.4172, "MZN": 63.9766, "NAD": 18.2279,
        "NGN": 1504.8538, "NIO": 36.8629, "NOK": 10.846, "NPR": 139.4182, "NZD": 1.7504, "OMR": 0.3845,
        "PAB": 1.0, "PEN": 3.6537, "PGK": 4.0835, "PHP": 57.3474, "PKR": 279.6527, "PLN": 3.8478,
        "PYG": 7924.5767, "QAR": 3.64, "RON": 4.5818, "RSD": 107.9496, "RUB": 89.0833, "RWF": 1434.4873,
        "SAR": 3.75, "SBD": 8.6195, "SCR": 14.6767, "SDG": 510.64, "SEK": 10.09, "SGD": 1.3307,
        "SHP": 0.7742, "SLE": 22.9991, "SLL": 22999.1079, "SOS": 573.1953, "SRD": 35.8266, "SSP": 4535.8769,
        "STN": 22.6093, "SYP": 12948.1689, "SZL": 18.2279, "THB": 33.6243, "TJS": 10.9546, "TMT": 3.5033,
        "TND": 3.0936, "TOP": 2.3946, "TRY": 36.4806, "TTD": 6.7748, "TVD": 1.5853, "TWD": 32.7985,
        "TZS": 2618.8403, "UAH": 41.2209, "UGX": 3672.0695, "UYU": 42.6369, "UZS": 12932.6023, "VES": 65.2662,
        "VND": 25520.768, "VUV": 124.3422, "WST": 2.8187, "XAF": 605.3368, "XCD": 2.7, "XDR": 0.7496,
        "XOF": 605.3368, "XPF": 110.1231, "YER": 247.2948, "ZAR": 18.2249, "ZMW": 28.6215, "ZWL": 26.6412
      };
    }
  }

  async detectCurrencyFromIP() {
    try {
      console.log('currency-switcher.js 正在通过 IP 检测货币...');
      let countryCode = localStorage.getItem('countryCode');
      let selectedCountry = localStorage.getItem('selectedCountry');
      let currency = localStorage.getItem('bucksCurrency');

      if (!countryCode || !selectedCountry || !currency) {
        const response = await fetch(this.options.ipLookupUrl);
        if (!response.ok) throw new Error(`HTTP 错误! 状态码: ${response.status}`);
        const data = await response.json();

        if (!countryCode && data.country_code) {
          countryCode = data.country_code;
          console.log('currency-switcher.js 未发现本地有国家代码，保存', countryCode);
          localStorage.setItem('countryCode', countryCode);
        }

        if (!selectedCountry && data.country_name) {
          selectedCountry = data.country_name;
          console.log('currency-switcher.js 未发现本地有国家名称，保存', selectedCountry);
          document.getElementById("shipping-estimator-country").value = selectedCountry;
          const event = new Event('change');
          document.getElementById("shipping-estimator-country").dispatchEvent(event);
          localStorage.setItem('selectedCountry', selectedCountry);
        }

        if (!currency && data.currency && this.rates[data.currency]) {
          currency = data.currency;
          console.log('currency-switcher.js 未发现本地有货币代码，保存', currency);
          localStorage.setItem('bucksCurrency', currency);
        }
      }

      if (currency && this.rates[currency]) {
        this.currentCurrency = currency;
        console.log('currency-switcher.js 检测到的货币:', this.currentCurrency);
        console.log('currency-switcher.js 国家代码:', countryCode);
        console.log('currency-switcher.js 国家名称:', selectedCountry);
      }
    } catch (error) {
      console.error('currency-switcher.js 通过 IP 检测货币时出错:', error);
      this.currentCurrency = this.options.defaultCurrency;
      localStorage.setItem('bucksCurrency', this.currentCurrency);
    }
  }

  processMoneyElements() {
    const moneyElements = document.querySelectorAll(this.options.selector);
    console.log(`currency-switcher.js 找到 ${moneyElements.length} 带有选择器的元素： ${this.options.selector}`);
    if (moneyElements.length === 0) {
      console.warn('currency-switcher.js 未找到价格元素。请确保 HTML 包含"money"元素。');
    }

    moneyElements.forEach(element => {
      if (element.classList.contains('buckscc-converted')) return;
      const originalValue = element.textContent.trim();
      const numericValue = this.extractNumericValue(originalValue);
      if (numericValue !== null) {
        element.setAttribute('bucks-original', originalValue);
        element.setAttribute('bucks-init', numericValue);
        element.setAttribute('bucks-currency', this.options.defaultCurrency);
        element.setAttribute('bucks-current', originalValue);

        let convertedAmount = numericValue;
        if (this.currentCurrency !== this.options.defaultCurrency &&
            this.rates[this.options.defaultCurrency] &&
            this.rates[this.currentCurrency]) {
          const amountInUSD = numericValue / this.rates[this.options.defaultCurrency];
          convertedAmount = amountInUSD * this.rates[this.currentCurrency];
        }
        element.setAttribute('bucks-converted-raw', convertedAmount);
        element.setAttribute('data-locked', 'true');

        element.classList.add('buckscc-converted', 'buckscc-money');
        if (this.currentCurrency !== this.options.defaultCurrency) this.convertElement(element);
      }
    });
  }

  extractNumericValue(moneyString) {
    const numericValue = parseFloat(moneyString.replace(/[^0-9.-]+/g, ''));
    return isNaN(numericValue) ? null : numericValue;
  }

  convertElement(element) {
    const originalCurrency = element.getAttribute('bucks-currency');
    const originalAmount = parseFloat(element.getAttribute('bucks-init'));
  
    if (isNaN(originalAmount)) return;
  
    let convertedAmount = originalAmount;
    if (originalCurrency !== this.currentCurrency &&
        this.rates[originalCurrency] &&
        this.rates[this.currentCurrency]) {
      const amountInUSD = originalAmount / this.rates[originalCurrency];
      // 四舍五入到整数
      convertedAmount = Math.round(amountInUSD * this.rates[this.currentCurrency]);
    } else {
      // 如果货币未更改，也确保四舍五入
      convertedAmount = Math.round(convertedAmount);
    }
  
    // 设置 bucks-converted-raw 为四舍五入后的值
    element.setAttribute('bucks-converted-raw', convertedAmount);

    // 添加转换后的货币代码属性
    element.setAttribute('target-currency', this.currentCurrency);    
  
    const symbolInfo = this.symbols[this.currentCurrency] || { symbol: this.currentCurrency, position: "before" };
    const symbol = symbolInfo.symbol;
    const position = symbolInfo.position;
  
    // 获取格式化规则
    const format = this.numberFormat[this.currentCurrency] || this.numberFormat['default'];
    const thousandsSeparator = format.thousands;
    const decimalSeparator = format.decimal;
    const noDecimals = format.noDecimals || false;
  
    // 修改：根据 noDecimals 决定是否附加 .00
    const formattedAmount = noDecimals
      ? convertedAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator)
      : convertedAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator) + decimalSeparator + "00";
  
    const displayValue = position === 'before'
      ? `${symbol}${formattedAmount}`
      : `${formattedAmount} ${symbol}`;
  
    element.setAttribute('bucks-current', displayValue);
    element.textContent = displayValue;
  }

  createCurrencyDropdown() {
    const selectors = Array.isArray(this.options.dropdownSelector)
      ? this.options.dropdownSelector
      : [this.options.dropdownSelector];
  
    // 定义优先级货币列表
    const priorityCurrencies = ['USD', 'EUR', 'JPY', 'GBP', 'CNY', 'AUD', 'CAD', 'CHF', 'HKD', 'SGD', 'KRW', 'NZD', 'SEK', 'NOK', 'MXN', 'INR', 'RUB', 'ZAR', 'TRY', 'BRL'];
  
    selectors.forEach(selector => {
      const container = document.querySelector(selector);
      if (!container) {
        console.error(`currency-switcher.js 未找到货币下拉容器：${selector}。请在 HTML 中添加 <div class="${selector.slice(1)}"`);
        return;
      }
  
      container.innerHTML = '';
      const dropdown = document.createElement('div');
      dropdown.className = 'currency-dropdown-wrapper';
  
      const initialSymbol = this.symbols[this.currentCurrency].symbol || this.currentCurrency;
      dropdown.innerHTML = `
        <span class="current-currency">${initialSymbol} ${this.currentCurrency}</span>
        <svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
          <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>
        </svg>
        <div class="currency-dropdown" style="display: none; color: #677279;">
          <input type="text" class="currency-search" />
          <ul class="currency-list">
            ${[
              // 优先级货币
              ...priorityCurrencies.filter(currency => this.rates[currency]),
              // 其余货币按字母顺序
              ...Object.keys(this.rates)
                .filter(currency => !priorityCurrencies.includes(currency))
                .sort()
            ].map(currency => {
              const symbolInfo = this.symbols[currency] || { symbol: currency, position: "before" };
              return `
                <li data-currency="${currency}" class="${currency === this.currentCurrency ? 'active' : ''}">
                  ${symbolInfo.symbol} ${currency}
                </li>
              `;
            }).join('')}
          </ul>
        </div>
      `;

      container.appendChild(dropdown);

      const dropdownContent = dropdown.querySelector('.currency-dropdown');
      const searchInput = dropdown.querySelector('.currency-search');
      const currencyList = dropdown.querySelector('.currency-list');

      if (!searchInput) {
        console.error('currency-switcher.js 未找到 .currency-search 输入框');
        return;
      }
      if (!currencyList) {
        console.error('currency-switcher.js 未找到 .currency-list 列表');
        return;
      }
      
      dropdown.addEventListener('click', (e) => {
        if (e.target.closest('.currency-dropdown')) return;
      
        const isVisible = dropdownContent.style.display === 'block';
        dropdownContent.style.display = isVisible ? 'none' : 'block';
      
        if (!isVisible) {
          searchInput.focus();
          searchInput.value = '';
          this.filterCurrencies('');
      
          // 获取容器和视口信息
          const rect = dropdown.getBoundingClientRect();
          const dropdownWidth = 200; // 下拉框宽度，如果有变请同步
          const dropdownHeight = 300; // 近似高度（最多300px）
          const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      
          // 判断是否靠近底部（默认向下，底部空间不足时向上）
          if (rect.bottom + dropdownHeight > viewportHeight) {
            dropdownContent.style.top = 'auto';
            dropdownContent.style.bottom = '100%';
            dropdownContent.style.marginTop = '0';
            dropdownContent.style.marginBottom = '5px';
          } else {
            dropdownContent.style.top = '100%';
            dropdownContent.style.bottom = 'auto';
            dropdownContent.style.marginBottom = '0';
            dropdownContent.style.marginTop = '5px';
          }
      
          // 判断是否靠近右边（默认左对齐，右边空间不足时靠右对齐）
          if (rect.left + dropdownWidth > viewportWidth) {
            dropdownContent.style.left = 'auto';
            dropdownContent.style.right = '0';
          } else {
            dropdownContent.style.left = '0';
            dropdownContent.style.right = 'auto';
          }
        }
      });




      searchInput.addEventListener('input', (e) => {
        const searchTerm = e.target.value.trim().toLowerCase();
        this.filterCurrencies(searchTerm);
      });

      currencyList.addEventListener('click', (e) => {
        const item = e.target.closest('li');
        if (!item) return;
        const currency = item.getAttribute('data-currency');
        const newSymbol = this.symbols[currency].symbol || currency;
        this.switchCurrency(currency);
        dropdownContent.style.display = 'none';
        const currentCurrencyDisplay = dropdown.querySelector('.current-currency');
        currentCurrencyDisplay.textContent = `${newSymbol} ${currency}`;
        currencyList.querySelectorAll('li').forEach(li => li.classList.remove('active'));
        item.classList.add('active');
      });

      document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target)) {
          dropdownContent.style.display = 'none';
        }
      });
    });
  }

  filterCurrencies(searchTerm) {
    const currencyItems = document.querySelectorAll('.currency-list li');
    if (currencyItems.length === 0) {
      console.error('currency-switcher.js 未找到 .currency-list li 元素');
      return;
    }
    currencyItems.forEach(item => {
      const currency = item.getAttribute('data-currency').toLowerCase();
      const symbolInfo = this.symbols[currency] || { symbol: currency, position: 'before' };
      const symbol = (symbolInfo.symbol || '').toLowerCase();
      const text = `${symbol} ${currency}`.toLowerCase();
      const isVisible = text.includes(searchTerm);
      item.style.display = isVisible ? 'block' : 'none';
    });
  }

  switchCurrency(newCurrency) {
    if (!this.rates[newCurrency]) {
      console.error('Invalid currency:', newCurrency);
      return;
    }

    this.currentCurrency = newCurrency;
    localStorage.setItem('bucksCurrency', newCurrency);

    document.querySelectorAll('.buckscc-money').forEach(element => this.convertElement(element));

    const selectors = Array.isArray(this.options.dropdownSelector)
      ? this.options.dropdownSelector
      : [this.options.dropdownSelector];

    selectors.forEach(selector => {
      const container = document.querySelector(selector);
      if (container) {
        const currentCurrencyDisplay = container.querySelector('.current-currency');
        const symbol = this.symbols[newCurrency].symbol || newCurrency;
        if (currentCurrencyDisplay) {
          currentCurrencyDisplay.textContent = `${symbol} ${newCurrency}`;
        }

        const currencyItems = container.querySelectorAll('.currency-list li');
        currencyItems.forEach(item => {
          const currency = item.getAttribute('data-currency');
          item.classList.toggle('active', currency === newCurrency);
        });
      }
    });

    document.dispatchEvent(new CustomEvent('bucksCurrency:changed', { detail: { currency: newCurrency } }));
    console.log('currency-switcher.js 货币切换为：', newCurrency);
  }

  observePriceChanges() {
    const targetNode = document.body;
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const moneyElements = document.querySelectorAll(this.options.selector);
          moneyElements.forEach(element => {
            const isShippingPrice = element.closest('.shipment_right, .expedited_shipping') !== null;
            const isProductPrice = element.closest('.product-form__info-item--price, .price') !== null;
            const currentValue = element.textContent.trim();
            const originalValue = element.getAttribute('bucks-original');
            const bucksCurrent = element.getAttribute('bucks-current');
            const isValidCurrencyFormat = /^[£$€¥]?\s*\d+([.,]\d{1,2})?([£$€¥]|\s*[A-Z]{3})?$/.test(currentValue);

            if (isProductPrice || isShippingPrice) {
              element.removeAttribute('data-locked');
            }

            if ((!element.classList.contains('buckscc-converted') ||
                (currentValue !== bucksCurrent && isValidCurrencyFormat)) &&
                (element.getAttribute('data-locked') !== 'true' || isProductPrice || isShippingPrice)) {
              const numericValue = this.extractNumericValue(currentValue);
              if (numericValue !== null) {
                element.setAttribute('bucks-init', numericValue);
                element.setAttribute('bucks-original', currentValue);
                element.setAttribute('bucks-currency', this.options.defaultCurrency);

                if (!element.classList.contains('buckscc-converted')) {
                  element.classList.add('buckscc-converted', 'buckscc-money');
                }

                if (!isProductPrice && !isShippingPrice) {
                  element.setAttribute('data-locked', 'true');
                }

                this.convertElement(element);
              }
            }
          });
        }
      });
    });

    const config = { childList: true, subtree: true, characterData: true };
    observer.observe(targetNode, config);
    this.priceObserver = observer;
  }

  setSymbolPosition(position) {
    if (position === 'before' || position === 'after') {
      this.options.symbolPosition = position;
      document.querySelectorAll('.buckscc-money').forEach(element => this.convertElement(element));
    }
  }

  addCustomSymbol(currency, symbol, position = 'before') {
    this.symbols[currency] = { symbol, position };
    if (this.currentCurrency === currency) {
      document.querySelectorAll('.buckscc-money').forEach(element => this.convertElement(element));
    }
  }

  setNumberFormat(currency, thousands, decimal, noDecimals = false) {
    this.numberFormat[currency] = { thousands, decimal, noDecimals };
    if (this.currentCurrency === currency) {
      document.querySelectorAll('.buckscc-money').forEach(element => this.convertElement(element));
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
    console.log('currency-switcher.js DOM 已完全加载，正在初始化……');

    const getCurrencyFromUrl = () => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('currency')?.toUpperCase();
    };

    const urlCurrency = getCurrencyFromUrl();
    console.log('currency-switcher.js URL 货币:', urlCurrency || '未提供');

    // 第一时间保存 URL 中的货币代码到 localStorage
    if (urlCurrency) {
        try {
            localStorage.setItem('bucksCurrency', urlCurrency);
            console.log('currency-switcher.js 第一时间保存 URL 货币到 localStorage方便paypal调用:', urlCurrency);
        } catch (error) {
            console.error('currency-switcher.js 保存到 localStorage 失败:', error);
        }
    }

    const countryCode = localStorage.getItem('countryCode');
    const selectedCountry = localStorage.getItem('selectedCountry');
    const savedCurrency = localStorage.getItem('bucksCurrency');
    console.log('currency-switcher.js 本地国家代码:', countryCode || '未设置');
    console.log('currency-switcher.js 本地国家:', selectedCountry || '未设置');
    console.log('currency-switcher.js 本地货币:', savedCurrency || '未设置');

    window.bucksCurrency = new BucksCurrency({
        symbolPosition: 'before',
        autoSwitch: true,
        dropdownSelector: [
            '.currency-value-picker-wrapper',
            '.header_currency-value-picker-wrapper',
            '.product_currency-value-picker-wrapper'
        ],
        defaultCurrency: 'USD'
    });
});

const style = document.createElement('style');
style.textContent = `
.currency-dropdown {
  position: absolute;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  z-index: 100;
  width: 200px;
  top: 100%;
  left: 0;
  margin-top: 5px;
}

  @media (max-width: 480px) {
    .currency-dropdown {
      width: auto;
      min-width: 150px;
      max-width: 90%;
    }
  }
  .currency-search {
    width: 100%;
    padding: 6px;
    margin-bottom: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .currency-list {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 300px;
    overflow-y: auto;
  }
  .currency-list li {
    padding: 8px 15px;
    cursor: pointer;
    transition: background 0.2s;
    display: block;
  }
  .currency-list li:hover {
    color: #00badb;
    background: #ebfafc;
  }
  .currency-list li.active {
    background: #ebfafc;
    font-weight: bold;
    color: #00badb;
  }
  .select-button {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    background: #f0f0f0;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  .current-currency {
    display: inline-block;
  }
`;

document.head.appendChild(style);